import type {
  IDataViewCategoryScope,
  IDataViewHeaderConfig,
  IUseDataViewOptions,
}
  from '@/domains/investor/components/DataView/DataView.types'
import { computed } from 'vue'
import { EMainCategories } from '@/domains/investor/const/MainCategories.enum'
import { useDataView } from '@/domains/investor/components/DataView/DataView.composable'
import { useGeneralMeeting } from '@/domains/investor/general-meeting/composables/useGeneralMeeting'
import { useGeneralMeetingFilters } from '@/domains/investor/general-meeting/composables/useGeneralMeetingFilters'
import { ITEMS_PER_PAGE, GENERAL_MEETING_CATEGORIES } from '@/domains/investor/general-meeting/const/generalMeeting.const'
import { GENERAL_MEETING_FILTERS_LABELS, GENERAL_MEETING_HEADER_CONFIG } from '@/domains/investor/general-meeting/const/generalMeetingLabels.const'

const DEFAULT_GENERAL_MEETING_CATEGORY_SCOPE: IDataViewCategoryScope = {
  mainCategories: EMainCategories.PRESENTATION,
  allowedSecondCategories: GENERAL_MEETING_CATEGORIES,
}

export const useGeneralMeetingDataView = async (options: IUseDataViewOptions = {}) => {
  const { useState } = useDataView()

  const {
    secondCategory,
    search,
    year,
    months,
    page,
    filters,
    clearFilters,
    onSearch,
    filterOptions,
    hasActiveFilters,
  } = useState({
    defaultCategoryScope: DEFAULT_GENERAL_MEETING_CATEGORY_SCOPE,
    options: {
      enableSearch: false,
      ...options,
    },
    useFilters: useGeneralMeetingFilters,
  })

  const { generalMeetings, generalMeetingColumns, total, isLoading } = await useGeneralMeeting(
    filters,
    page,
    ITEMS_PER_PAGE,
  )

  const headerConfig = computed<IDataViewHeaderConfig>(() => GENERAL_MEETING_HEADER_CONFIG)

  return {
    secondCategory,
    search,
    year,
    months,
    page,
    itemsPerPage: ITEMS_PER_PAGE,
    filters,
    clearFilters,
    onSearch,
    filterOptions,
    generalMeetings,
    generalMeetingColumns,
    total,
    isLoading,
    hasActiveFilters,
    filterLabels: GENERAL_MEETING_FILTERS_LABELS,
    headerConfig,
  }
}
